import React from 'react';

export default function TestDefinisionCollaboratorsDescription(): JSX.Element {
  return (
    <>
      These policies control who can create tests from this test definition, as well as who can edit and
      control access for the test definition itself. Who can view tests created from this test definition is
      determined by what object the created test is attached to.
    </>
  );
}
